/** Local time-of-day greeting for dashboard header (midnight–noon / noon–6pm / 6pm–midnight). */
export function getTimeOfDayGreeting(date = new Date()) {
  const hour = date.getHours();
  if (hour < 12) return "Good morning";
  if (hour < 18) return "Good afternoon";
  return "Good evening";
}

export function getDisplayFirstName(user) {
  if (!user) return "";
  const first = String(user.first_name || "").trim();
  if (first) return first;
  const full = String(user.full_name || "").trim();
  if (full) return full.split(/\s+/)[0];
  return String(user.username || "").trim();
}

export function getDashboardGreeting(user, date = new Date()) {
  const greeting = getTimeOfDayGreeting(date);
  const name = getDisplayFirstName(user);
  return name ? `${greeting}, ${name}` : greeting;
}
